import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-base);
  padding: 40px var(--spacing-base);
  text-align: center;
`;

export const Message = styled.p`
  font-size: var(--font-size-text-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--black);
`;

export const Image = styled.img`
  max-width: 300px;
  width: 100%;
`;
